import React from 'react';
import { DISCIPLINE_BORDER } from '../../dtos/scheduling/schedule.dto';

/** Key for the schedule colours (plan §6.1: one colour system, explained once). */
const Legend: React.FC = () => (
  <details className="text-xs text-gray-600">
    <summary className="cursor-pointer select-none py-1 text-gray-500 hover:text-gray-800">Legend</summary>
    <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-md border border-gray-200 bg-white p-3">
      {Object.entries(DISCIPLINE_BORDER).map(([d, cls]) => (
        <span key={d} className="flex items-center gap-1.5">
          <span className={`inline-block h-4 w-1 rounded-sm border-l-4 ${cls}`} />{d}
        </span>
      ))}
      <span className="flex items-center gap-1.5"><span className="inline-block h-4 w-6 rounded border border-amber-300 bg-amber-50" />Patient on hold</span>
      <span className="flex items-center gap-1.5"><span className="inline-block h-4 w-6 rounded border border-dashed border-gray-400" />Unstaffed</span>
      <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-red-500" />Late (15+ min, no visit started)</span>
    </div>
  </details>
);

export default Legend;
